import { defineMessages } from "@/i18n";
import en from "./en";

export const libPlanMessages = defineMessages("lib-plan", en);
